import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="container">
        {/* Hero Section */}
        <section className="about-hero">
          <h1>About FreioLabs</h1>
          <p className="hero-subtitle">
            We're a cutting-edge technology company dedicated to building the future, one app at a time.
          </p>
        </section>

        {/* Mission Section */}
        <section className="mission-section">
          <div className="content-grid">
            <div className="text-content">
              <h2>Our Mission</h2>
              <p>
                At FreioLabs, we believe that technology should empower people and solve real-world problems. 
                Our mission is to create innovative digital solutions that bridge the gap between cutting-edge 
                AI capabilities and practical, user-friendly applications.
              </p>
              <p>
                We specialize in developing mobile apps, web applications, and AI-powered tools that not only 
                meet today's needs but anticipate tomorrow's challenges.
              </p>
            </div>
            <div className="visual-content">
              <div className="mission-visual">
                <div className="tech-icon">🚀</div>
                <div className="floating-elements">
                  <span className="element">AI</span>
                  <span className="element">Mobile</span>
                  <span className="element">Web</span>
                  <span className="element">Innovation</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section className="what-we-do">
          <h2>What We Do</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">📱</div>
              <h3>Mobile Development</h3>
              <p>Native iOS and Android apps that deliver exceptional user experiences and performance.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🌐</div>
              <h3>Web Applications</h3>
              <p>Scalable, responsive web platforms built with modern frameworks and best practices.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🤖</div>
              <h3>AI Integration</h3>
              <p>Intelligent features powered by the latest in machine learning and generative AI.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">⚡</div>
              <h3>Performance Optimization</h3>
              <p>Lightning-fast applications optimized for speed, efficiency, and user satisfaction.</p>
            </div>
          </div>
        </section>

        {/* Our Approach Section */}
        <section className="approach-section">
          <h2>Our Approach</h2>
          <div className="approach-timeline">
            <div className="timeline-item">
              <div className="timeline-icon">🔍</div>
              <div className="timeline-content">
                <h3>Discovery & Research</h3>
                <p>We start by understanding your needs, goals, and target audience through comprehensive research and analysis.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-icon">🎨</div>
              <div className="timeline-content">
                <h3>Design & Prototyping</h3>
                <p>Creating intuitive, beautiful designs that prioritize user experience and align with your brand identity.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-icon">⚙️</div>
              <div className="timeline-content">
                <h3>Development & Testing</h3>
                <p>Building robust, scalable solutions using cutting-edge technologies and rigorous testing practices.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-icon">🚀</div>
              <div className="timeline-content">
                <h3>Launch & Support</h3>
                <p>Deploying your application and providing ongoing support to ensure continued success and growth.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>🎯 Quality First</h3>
              <p>We never compromise on quality. Every line of code, every design element, and every user interaction is crafted with precision.</p>
            </div>
            <div className="value-item">
              <h3>🤝 Collaboration</h3>
              <p>We work closely with our clients as partners, ensuring transparency and alignment throughout the development process.</p>
            </div>
            <div className="value-item">
              <h3>🔬 Innovation</h3>
              <p>We stay at the forefront of technology trends, constantly exploring new tools and methodologies to deliver cutting-edge solutions.</p>
            </div>
            <div className="value-item">
              <h3>🎓 Continuous Learning</h3>
              <p>Technology evolves rapidly, and so do we. We're committed to continuous learning and improvement in everything we do.</p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="cta-content">
            <h2>Ready to Build Something Amazing?</h2>
            <p>Let's discuss your project and explore how we can bring your vision to life.</p>
            <div className="cta-buttons">
              <a href="/contact" className="cta-button primary">Start Your Project</a>
              <a href="/services" className="cta-button secondary">View Our Services</a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About; 